import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "43",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0083CC",
      d: "M30.923 11.875v25.943A5.18 5.18 0 0 1 25.741 43H5.181A5.18 5.18 0 0 1 0 37.818V5.182A5.18 5.18 0 0 1 5.182 0h13.866z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#52C1FF",
      d: "M30.923 11.875H21.19a2.14 2.14 0 0 1-2.142-2.141V0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.362 21.6h-1.78v7.358H9.33V21.6H7.567v-1.168h4.795zM16.805 28.958 15.461 25.8l-1.352 3.158h-1.36l2.032-4.418-1.915-4.107h1.352l1.243 2.89 1.226-2.89h1.353l-1.907 4.099 2.033 4.417h-1.361zM23.356 21.6h-1.78v7.358h-1.252V21.6h-1.772v-1.168h4.804z"
    }, null, -1)
  ])))
}
export default { render: render }